import { render, staticRenderFns } from "./LogText.vue?vue&type=template&id=19734bc8&"
import script from "./LogText.vue?vue&type=script&lang=js&"
export * from "./LogText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports